<div class="h-100 d-flex flex-column container">
  <!-- TOP SECTION (FILTERS, INVITE, SEARCH) -->
  <app-page-filters-and-cta>
    <app-text-search-filter
      search
      [context]="'user'"
      (searchTextChange)="onSearchChange($event)"></app-text-search-filter>

    <button filters hlmBtn variant="ghost" size="icon" (click)="openUserPropsFilterDialog()" [class.text-destructive]="filterDialogDirty">
      <ng-icon hlm name="lucideFilter" />
    </button>

    <button add-btn hlmBtn variant="outline" (click)="inviteUser()">
      Invite user
    </button>
  </app-page-filters-and-cta>

  <!-- END TOP SECTION -->

  @if (users()) {
    <main class="surface-container-bg">
      <div hlmTableContainer style="overflow-x: auto">
        <table hlm class="w-100" style="min-width: 980px">
          <thead hlmTHead>
            <tr hlmTr>
              <th hlmTh>Email</th>
              <th hlmTh>Company</th>
              <th hlmTh>First name</th>
              <th hlmTh>Surname</th>
              <th hlmTh>Role</th>
              <th hlmTh>Telephone</th>
              <th hlmTh>Actions</th>
            </tr>
          </thead>
          <tbody hlmTBody>
            @for (user of users(); track user._id) {
              <tr hlmTr>
                <td hlmTd><span class="font-mono text-muted-foreground">{{ formatId(user._id) }}</span></td>
                <td hlmTd>{{ ($any(user).tenants ? ($any(user).tenants[0] | titlecase) : '') }}</td>
                <td hlmTd>{{ user?.profile?.name }}</td>
                <td hlmTd>{{ user?.profile?.surname }}</td>
                <td hlmTd>{{ joinRoles(user.roles) | async }}</td>
                <td hlmTd>{{ user?.profile?.phone }}</td>
                <td hlmTd>
              <section class="d-flex">
                @if (currentUser()) {
                  @if (currentUser() && currentUser()!._id !== user._id) {
                    <button
                      hlmTooltipTrigger="Edit user details"
                      hlmBtn
                      variant="ghost"
                      size="icon"
                      (click)="openEditDialog(user)">
                      <ng-icon hlm name="lucidePencil" />
                    </button>
                  }
                }
                @if (user.pwdAuth) {
                  <!-- only native gets pwdAuth -->
                  <!-- nativa can send activation email and reset email -->
                  <button
                    hlmBtn
                    variant="ghost"
                    size="icon"
                    [disabled]="!canResendEmail"
                    hlmTooltipTrigger="{{
                      isLockedUser(user.roles)
                        ? 'Send email for activation'
                        : 'Send password reset email'
                    }}"
                    (click)="resendEmail(user._id)">
                    <ng-icon hlm name="lucideMail" />
                  </button>
                  @if (!user.pwdAuth.verified) {
                    <!-- nativa can also copy activation/reset link -->
                    <button
                      hlmBtn
                      variant="ghost"
                      size="icon"
                      hlmTooltipTrigger=" {{
                        isLockedUser(user.roles)
                          ? 'Copy activation link'
                          : 'Copy password reset link'
                      }}"
                      [cdkCopyToClipboard]="resetOrActivationLink(user)"
                      [cdkCopyToClipboardAttempts]="5">
                      <ng-icon hlm name="lucideCopy" />
                    </button>
                  }
                } @else if (isLockedUser(user.roles)) {
                  <!-- manager users can send activation email again -->
                  <button
                    hlmBtn
                    variant="ghost"
                    size="icon"
                    [disabled]="!canResendEmail"
                    hlmTooltipTrigger="Send email for activation"
                    (click)="resendEmail(user._id)">
                    <ng-icon hlm name="lucideMail" />
                  </button>
                }
              </section>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </main>
  }

  <!-- PAGINATION -->
  <ng-container>
    <section class="mt-auto d-flex justify-content-center mb-3">
      <hlm-numbered-pagination
        [totalItems]="userCollectionSize"
        [(currentPage)]="currentPage"
        [(itemsPerPage)]="itemsPerPage">
      </hlm-numbered-pagination>
    </section>
  </ng-container>
</div>
